import Home from "./components/Home/Home";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import TeamDetails from "./components/TeamDetails/TeamDetails.js";

function App() {
  return (
    <Router>
      <Switch>
      
        <Route path="/home">
          <Home />
        </Route>

        <Route path="/team/:teamID">
          <TeamDetails></TeamDetails>
        </Route>

        <Route exact path="*">
            <Home />
          </Route>

        
      </Switch>
    </Router>
  );
}

export default App;
